// extracted by mini-css-extract-plugin
export default {"liveRegion":"LiveRegion-module__liveRegion__iL4Ch"};